import styled from "@emotion/styled";
import { ExpertProfileRecord } from "@src/api/types";
import moment from "moment";

export const ProfileRecordItem = ({
	companyName,
	position,
	start,
	end,
	job,
	isCurrent,
}: ExpertProfileRecord) => {
	const startDate = moment(new Date(start));
	const endDate = moment(new Date(end));
	const diffDuration = moment.duration(endDate.diff(startDate));
	const diffYear = diffDuration.years();
	const diffMonth = diffDuration.months();
	const formattedDiffDate =
		(diffYear > 0 ? `${diffYear}년` : "") + (diffMonth > 0 ? `${diffMonth}개월` : "");

	return (
		<Wrapper>
			<StyledGroupA className="column-start-start">
				<div className="title">{companyName}</div>
				<div className="subTitle">{position}</div>
				<div className="date-box column-start-start">
					{isCurrent ? (
						<>
							<div className="date">
								{startDate.format("yyyy.MM")} ~ {"현재"}
							</div>
							<div className="period">재직중</div>
						</>
					) : (
						<>
							<div className="date">
								{startDate.format("yyyy.MM")} ~ {endDate.format("yyyy.MM")}
							</div>
							<div className="period">{formattedDiffDate} (재직기간)</div>
						</>
					)}
				</div>
			</StyledGroupA>
			<div className="content">{job}</div>
		</Wrapper>
	);
};

const StyledGroupA = styled.div`
	flex-basis: 130px;
	width: 130px;
	flex-grow: 0;
	flex-shrink: 0;
	gap: 4px;
	.group-a {
		flex-basis: 130px;
		width: 130px;
		flex-grow: 0;
		flex-shrink: 0;
	}
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: flex-start;
	gap: 10px;

	@media screen and (max-width: 768px) {
		flex-direction: column;
		align-items: start;
		justify-content: start;
		gap: 10px;
	}

	.top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.title {
		color: var(--card-bg);
		font-size: 20px;
		font-weight: 700;
		line-height: normal;
		letter-spacing: -0.64px;
		word-break: break-all;
		white-space: pre-wrap !important;
		width: auto !important;
	}

	.subTitle {
		color: var(--card-bg);
		font-size: 16px;
		font-weight: 700;
		line-height: normal;
		letter-spacing: -0.64px;
		word-break: break-all;
	}

	.date {
		color: var(--desc-gray);
		font-size: 12px;
		font-weight: 400;
		line-height: normal;
		white-space: nowrap;
		letter-spacing: -0.64px;
	}

	.period {
		color: var(--desc-gray);
		font-size: 12px;
		font-weight: 400;
		line-height: normal;
		white-space: nowrap;
		text-align: right;
		letter-spacing: -0.64px;
	}

	.content {
		display: flex;
		flex-direction: column;
		color: var(--desc-gray);
		font-size: 16px;
		font-weight: 500;
		line-height: 150%;
		letter-spacing: -0.64px;
	}
`;
